(function () {var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;enterModule && enterModule(module);})();var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {return a;}; /*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React from 'react';import { jsx as ___EmotionJSX } from "@emotion/react";




const CONTAINER_STYLE = {
  backgroundColor: '#000',
  color: '#fff',
  overflow: 'auto',
  padding: 32 };


export default function FallbackComponent({
  componentStack,
  error,
  height,
  width })
{
  return (
    ___EmotionJSX("div", { style: { ...CONTAINER_STYLE, height, width } },
    ___EmotionJSX("div", null,
    ___EmotionJSX("div", null,
    ___EmotionJSX("b", null, "Oops! An error occured!")),

    ___EmotionJSX("code", null, error ? error.toString() : 'Unknown Error')),

    componentStack &&
    ___EmotionJSX("div", null,
    ___EmotionJSX("b", null, "Stack Trace:"),
    ___EmotionJSX("code", null,
    componentStack.split('\n').map((row) =>
    ___EmotionJSX("div", { key: row }, row))))));






};(function () {var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;if (!reactHotLoader) {return;}reactHotLoader.register(CONTAINER_STYLE, "CONTAINER_STYLE", "/Users/ville/src/superset-release/superset-frontend/packages/superset-ui-core/src/chart/components/FallbackComponent.tsx");reactHotLoader.register(FallbackComponent, "FallbackComponent", "/Users/ville/src/superset-release/superset-frontend/packages/superset-ui-core/src/chart/components/FallbackComponent.tsx");})();;(function () {var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;leaveModule && leaveModule(module);})();